<template>
  <BaseInput
    type="text"
    :errors="props.errors"
    :id="props.id"
    :label="props.label"
    :max="props.max"
    :modelValue="props.modelValue"
    :placeholder="props.placeholder"
    :toolTipLabel="props.toolTipLabel"
    :loading="props.loading"
    :disabled="props.disabled"
    @update:modelValue="(value: string) => $emit('update:modelValue', value)"
  />
</template>

<script setup lang="ts">
import {ErrorObject} from "@vuelidate/core";
import BaseInput from "@/components/FormInputs/BaseInput.vue";

defineEmits<{
  'update:modelValue': [value: string];
}>();

const props = defineProps<{
  id: string;
  modelValue: string;
  disabled?: boolean;
  placeholder?: string;
  label?: string;
  max?: number;
  toolTipLabel?: string;
  errors?: ErrorObject[];
  loading?: boolean;
}>();
</script>
